var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"videoContainer",staticClass:"video-box"},[_c('video',{ref:"videoPlayer",staticClass:"video-js"})])
}
var staticRenderFns = []

export { render, staticRenderFns }